/* eslint-disable consistent-return */

import { useEffect } from 'react';

/**
 * Locks the viewport based on the locked param passed in.
 */
const useLockViewportScrolling = (locked: boolean) => {
    // gets the <html> element.
    const getHtmlElement = () => (
        typeof window !== 'undefined' ? document.querySelector('body') : undefined
    );

    // Adds and removes overflow depending on the locked param passed in.
    useEffect(() => {
        const htmlElement = getHtmlElement();
        if (!htmlElement) {
            return;
        }

        if (locked) {
            htmlElement.style.setProperty('overflow', 'hidden');
        } else {
            htmlElement.style.removeProperty('overflow');
        }
    }, [locked]);

    // Removes the overflow property on unmount.
    useEffect(() => {
        const htmlElement = getHtmlElement();
        if (!htmlElement) {
            return;
        }

        return () => {
            htmlElement.style.removeProperty('overflow');
        }
    }, []);
};

export default useLockViewportScrolling;
